module.exports = __webpack_public_path__ + "/american-girl/courtney-mall-game/static/media/map-cinema.1ae60d21.png";